import { styled, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';

export const StyledCopyIconButton = styled(IconButton)(({ theme }) => ({
  height: theme.spacing(5.5),
  width: theme.spacing(5.5),
  backgroundColor: '#e5e7eb',
  '&:hover': {
    backgroundColor: '#d1d5db',
  },
  '&:disabled': {
    backgroundColor: '#d1d5db',
  },
}));

export const StyledContentCopyIcon = styled(ContentCopyIcon)({});

export const StyledDoneIcon = styled(DoneIcon)({
  color: '#4CAF50',
});
